import { convertToHTML } from "draft-convert";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner
} from "reactstrap";

import OnlyHeader from "components/Headers/OnlyHeader";
import MediaPicker from "components/MediaPicker";
import { toast } from "react-toastify";
import { addHelpArticle } from "store/actions/helpArticleAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const AddArticle = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { addHelpArticlesLoader } = useSelector((state) => state.helpArticles);

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const [selectedValues, setSelectedValues] = useState([]);
  const [newImage, setNewImage] = useState(null);
  console.log(newImage);

  const [articleData, setArticleData] = useState({
    title: "",
    description: "",
    content: "",
    file: ""
  });
  console.log("articleData: ", articleData);

  const handleEditorChange = (state) => {
    setEditorState(state);
    convertContentToHTML();
  };

  const convertContentToHTML = () => {
    let currentContentAsHTML = convertToHTML(editorState.getCurrentContent());
    setArticleData((prevData) => ({
      ...prevData,
      content: currentContentAsHTML
    }));
  };

  const handleArticleDataChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "featuredImgURL" || name === "getMediaURL") {
      setArticleData((prevData) => ({
        ...prevData,
        [name]: files[0]
      }));
    } else {
      setArticleData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
  };

  const uploadImageCallback = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve({ data: { link: reader.result } });
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const handlePastedText = (text, html, editorState) => {
    if (html && html.includes("<img")) {
      toast.error(
        "Use the image toolbar to upload, paste or add image URLs. Direct image pasting into the editor is not allowed."
      );
      return true;
    }
    return false;
  };

  const handleSubmit = () => {
    if (!articleData.title || !articleData.content || !articleData.file) {
      toast.error("Please fill all the required fields");
      return;
    }

    const temp = {
      ...articleData,
      content: draftToHtml(convertToRaw(editorState.getCurrentContent()))
    };

    const payload = {
      title: temp.title,
      description: temp.description,
      content: temp.content,
      file: temp.file
    };
    console.log({ payload });

    dispatch(
      addHelpArticle(payload, () => {
        history.push("/admin/help-articles");
      })
    );
  };
  const embedVideoCallBack = (iframeHtml) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = iframeHtml.trim();
    const iframeElement = tempDiv.querySelector("iframe");
    if (iframeElement) {
      const src = iframeElement.getAttribute("src");
      const cleanSrc = src.split("?")[0];
      return cleanSrc;
    } else {
      return null;
    }
  };

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0 bg-white d-flex justify-content-between align-items-center flex-wrap">
                <div className="mb-2 mb-sm-0">
                  <h3 className="mb-0 text-dark font-weight-bold">
                    <i className="fas fa-plus-circle mr-2 text-primary" />
                    Create Help Article
                  </h3>
                  <small className="text-muted">
                    Publish a new help article with description, cover image, and content.
                  </small>
                </div>
                <Button
                  color="secondary"
                  size="sm"
                  onClick={() => history.push("/admin/help-articles")}
                >
                  <i className="fas fa-arrow-left mr-1" /> Back to Articles
                </Button>
              </CardHeader>
              <CardBody className="pt-2">
                <Row>
                  <Col md="6" className="my-2">
                    <FormGroup>
                      <Label className="form-control-label font-weight-bold">
                        Article Title <span className="text-danger">*</span>
                      </Label>
                      <Input
                        name="title"
                        placeholder="Enter article title..."
                        value={articleData.title}
                        required
                        onChange={(e) => {
                          handleArticleDataChange(e);
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" className="my-2">
                    <FormGroup>
                      <Label className="form-control-label font-weight-bold">
                        Article Description <span className="text-danger">*</span>
                      </Label>
                      <Input
                        name="description"
                        placeholder="Enter article description..."
                        value={articleData.description}
                        required
                        onChange={(e) => {
                          handleArticleDataChange(e);
                        }}
                      />
                    </FormGroup>
                  </Col>

                  <Col md="12" className="my-2">
                    <FormGroup>
                      <Label className="form-control-label font-weight-bold d-block">
                        Cover Image / Media <span className="text-danger">*</span>
                      </Label>
                      <div className="article_media">
                        <MediaPicker
                          media={articleData.file}
                          onImageChange={(newFile) => {
                            setArticleData((prevData) => ({
                              ...prevData,
                              file: newFile,
                            }));
                          }}
                        />
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md="12" className="mt-3">
                    <FormGroup>
                      <Label className="form-control-label font-weight-bold">
                        Article Content <span className="text-danger">*</span>
                      </Label>
                      <Editor
                        editorState={editorState}
                        wrapperStyle={{
                          border: "1px solid #dee2e6",
                          borderRadius: "0.375rem",
                          boxShadow: "0 1px 3px rgba(50, 50, 93, 0.05)",
                          overflow: "hidden",
                        }}
                        toolbarStyle={{
                          borderBottom: "1px solid #dee2e6",
                          backgroundColor: "#f8f9fe",
                          marginBottom: 0,
                          padding: "8px 12px",
                        }}
                        editorStyle={{
                          minHeight: "450px",
                          maxHeight: "750px",
                          overflowY: "auto",
                          padding: "16px 20px",
                          backgroundColor: "#ffffff",
                          lineHeight: "1.6",
                        }}
                        toolbar={{
                          embedded: {
                            embedCallback: embedVideoCallBack,
                            defaultSize: {
                              height: "auto",
                              width: "auto",
                            },
                          },
                          image: {
                            urlEnabled: true,
                            uploadEnabled: true,
                            uploadCallback: uploadImageCallback,
                            previewImage: true,
                            alt: { present: true, mandatory: false },
                          },
                          blockType: {
                            options: [
                              "Normal",
                              "H1",
                              "H2",
                              "H3",
                              "H4",
                              "H5",
                              "H6",
                              "Blockquote",
                            ],
                          },
                          fontFamily: {
                            options: [
                              "Arial",
                              "Georgia",
                              "Impact",
                              "Tahoma",
                              "Times New Roman",
                              "Verdana",
                              "Barlow",
                            ],
                          },
                        }}
                        handlePastedText={handlePastedText}
                        onEditorStateChange={handleEditorChange}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <div className="d-flex justify-content-end align-items-center mt-4 pt-3 border-top">
                  <Button
                    type="button"
                    color="secondary"
                    className="mr-2"
                    onClick={() => history.push("/admin/help-articles")}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="button"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={addHelpArticlesLoader || !articleData.title}
                  >
                    {addHelpArticlesLoader ? (
                      <Spinner
                        className="d-flex mx-auto align-items-center justify-content-center overflow-hidden"
                        size="sm"
                        color="white"
                        disabled={addHelpArticlesLoader}
                      />
                    ) : (
                      <>
                        <i className="fas fa-save mr-1" /> SAVE ARTICLE
                      </>
                    )}
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddArticle;
